import ProductBundles from './components/product';
import styles from './index.module.scss';

export default function Comp({ addShopCartCallback }: any) {
    return (
        <div className={styles.comp}>
            <ProductBundles addShopCartCallback={addShopCartCallback} />
        </div>
    );
}
